import React, { Component } from "react";

//import icon
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { toast } from "react-toastify";

const prices = [
  "Less than ₹1500",
  "₹1500 - ₹2500",
  "₹2500 - ₹4000",
  "₹4000 - ₹8000",
  "More than ₹8000",
];

export default class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      dropdownOpen: false,
      isSubmitting: false,
      // form states
      firstName: "",
      lastName: "",
      whatsappNumber: "",
      billAmount: "",
      email: "",
      pinCode: "",
      city: "",
      // form erros
      errors: {},
    };
  }

  // Tabs toggle between solutions
  toggleSolutionTab = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  // Open drop down for money bill
  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  selectOption = (option) => {
    this.setState({ billAmount: option });
  };

  // handle states of form
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // submit form
  validateForm = () => {
    const {
      firstName,
      lastName,
      whatsappNumber,
      email,
      billAmount,
      pinCode,
      city,
    } = this.state;
    const errors = {};

    // Firstname
    if (!firstName.trim()) errors.firstName = "First Name is required.";

    // Lastname
    if (!lastName.trim()) errors.lastName = "Last Name is required.";

    // Whatsup number
    if (!whatsappNumber.trim()) {
      errors.whatsappNumber = "WhatsApp number is required.";
    } else if (!/^\d{10}$/.test(whatsappNumber)) {
      errors.whatsappNumber = "Enter a valid 10-digit WhatsApp number.";
    }

    // email
    if (!email.trim()) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Enter a valid email address.";
    }

    // bill amount
    if (!billAmount) {
      errors.billAmount = "Please select a bill amount.";
    }

    // pincode
    if (!pinCode.trim()) {
      errors.pinCode = "Pin code is required.";
    } else if (!/^\d{6}$/.test(pinCode)) {
      errors.pinCode = "Enter a valid 6-digit pin code.";
    }

    // city
    if (!city.trim()) {
      errors.city = "City is required.";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ isSubmitting: true });

    if (!this.validateForm()) {
      this.setState({ isSubmitting: false });
      return;
    }

    try {
      const payload = {
        shopId: "nNAkKgw6mnmlbyTAhEdX8R3TLF1cK8",
        userFirstName: this.state.firstName,
        userLastName: this.state.lastName,
        userEmail: this.state.email,
        userMobileNumber: `+91${this.state.whatsappNumber}`,
        emailSubject: `We're Here to Help with Your ${
          this.state.activeTab === 0 ? "Home" : "Commercial"
        } Solutions!`,
        emailBody: `Electricity bill: ${this.state.billAmount.replaceAll(
          "₹",
          "Rs."
        )}, City: ${this.state.city}, Pincode:${
          this.state.pinCode
        }. I need assistance with my solar solutions.`,
      };

      // console.log(payload);

      const res = await fetch(
        "https://869trrme06.execute-api.ap-south-1.amazonaws.com/sns-prod/email/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      // const resJSON = await res.json();

      // console.log(resJSON);

      if (res.ok) {
        toast.success(
          `Thank you, ${this.state.firstName} ${this.state.lastName}! Your details have been submitted successfully`
        );

        this.setState({
          firstName: "",
          lastName: "",
          whatsappNumber: "",
          billAmount: "",
          email: "",
          pinCode: "",
          city: "",
          errors: {},
        });
      } else throw new Error("Failed to submit the form.");
    } catch (error) {
      console.log(error);
      toast.error("An error occurred. Please try again.");
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        <section className="section" id="contact-us">
          <Container>
            <Row className="justify-content-center">
              <Col lg={7}>
                <div className="text-center mb-5">
                  <h2 className="service-title f-24">CONTACT US</h2>
                  <h3
                    className="hero-1-title fw-normal"
                    style={{ color: "#2077b8" }}
                  >
                    Share your details, and we’ll help you start your solar
                    journey.
                  </h3>
                </div>

                <div className="custom-form mt-4 mt-lg-0">
                  <Card style={{ maxWidth: "420px", margin: "auto" }}>
                    <CardBody>
                      <Form
                        method="post"
                        name="contact-form"
                        id="contact-form"
                        onSubmit={this.handleSubmit}
                      >
                        <Row>
                          {/* Tabs */}
                          <Col sm={12}>
                            <FormGroup
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                gap: 20,
                              }}
                            >
                              <Button
                                color={
                                  this.state.activeTab === 0
                                    ? "primary"
                                    : "secondary"
                                }
                                style={{
                                  width: "50%",
                                  borderRadius: "20px",
                                }}
                                onClick={() => this.toggleSolutionTab(0)}
                                size="sm"
                              >
                                Home Solution
                              </Button>
                              <Button
                                color={
                                  this.state.activeTab === 1
                                    ? "primary"
                                    : "secondary"
                                }
                                style={{
                                  width: "50%",
                                  borderRadius: "20px",
                                }}
                                onClick={() => this.toggleSolutionTab(1)}
                                size="sm"
                              >
                                Commercial Solution
                              </Button>
                            </FormGroup>
                          </Col>
                          {/* Form */}
                          <Col sm={6}>
                            <FormGroup>
                              <Label for="firstName">
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="text"
                                name="firstName"
                                id="firstName"
                                value={this.state.firstName}
                                onChange={this.handleInputChange}
                                placeholder="Enter your first name"
                              />
                              {this.state.errors.firstName && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.firstName}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={6}>
                            <FormGroup>
                              <Label for="lastName">
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="text"
                                name="lastName"
                                id="lastName"
                                value={this.state.lastName}
                                onChange={this.handleInputChange}
                                placeholder="Enter your last name"
                              />
                              {this.state.errors.lastName && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.lastName}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={12}>
                            <FormGroup>
                              <Label for="whatsappNumber">
                                WhatsApp Number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="text"
                                name="whatsappNumber"
                                id="whatsappNumber"
                                value={this.state.whatsappNumber}
                                onChange={this.handleInputChange}
                                placeholder="Enter your WhatsApp number"
                              />
                              {this.state.errors.whatsappNumber && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.whatsappNumber}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={12}>
                            <FormGroup>
                              <Label for="email">Email</Label>
                              <Input
                                type="email"
                                name="email"
                                id="email"
                                value={this.state.email}
                                onChange={this.handleInputChange}
                                placeholder="Enter your email"
                              />
                              {this.state.errors.email && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.email}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={12}>
                            <FormGroup>
                              <Label>
                                Monthly Electricity Bill{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <select
                                name="billAmount"
                                id="billAmount"
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  padding: "8px 10px",
                                  fontSize: "14px",
                                  height: "40px",
                                  backgroundColor: "rgba(52, 58, 64, 0.01)",
                                  border: "1px solid rgba(155, 155, 174, 0.3)",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                }}
                                onChange={(e) =>
                                  this.selectOption(e.target.value)
                                }
                              >
                                <option value="" style={{ cursor: "pointer" }}>
                                  Select
                                </option>
                                {prices.map((x, index) => (
                                  <option
                                    value={x}
                                    key={index}
                                    style={{
                                      padding: "8px 12px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {x}
                                  </option>
                                ))}
                              </select>
                              {this.state.errors.billAmount && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.billAmount}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={6}>
                            <FormGroup>
                              <Label for="pinCode">
                                Pin Code <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                type="text"
                                name="pinCode"
                                id="pinCode"
                                value={this.state.pinCode}
                                onChange={this.handleInputChange}
                                placeholder="Enter your pin code"
                              />
                              {this.state.errors.pinCode && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.pinCode}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm={6}>
                            <FormGroup>
                              <Label for="city">City</Label>
                              <Input
                                type="text"
                                name="city"
                                id="city"
                                value={this.state.city}
                                onChange={this.handleInputChange}
                                placeholder="Enter your city"
                              />
                              {this.state.errors.city && (
                                <div
                                  className="text-danger"
                                  style={{ fontSize: "12px" }}
                                >
                                  {this.state.errors.city}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          {/* Submit Button */}
                          <Col sm={12}>
                            <Button
                              type="submit"
                              color="primary"
                              style={{
                                borderRadius: "20px",
                                cursor: this.state.isSubmitting
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              disabled={this.state.isSubmitting}
                            >
                              {this.state.isSubmitting
                                ? "SUBMITTING..."
                                : "SUBMIT"}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}
